<template>
  <div
    class="w-full d-theme-dark-bg fixed shadow-lg"
    style="bottom:0px; left: 0px; z-index:10000"
  >
    <div class="flex justify-between items-center px-3">
      <AppNavbarFooterItem
        v-for="(item, index) in navigationsLeft"
        :key="'l-' + index"
        :item="item"
        :active="navigationActive"
      />
      <vs-button
        @click="toggleCreate(true)"
        radius
        size=""
        class="shadow-md z-20"
        color="primary"
        type="filled"
        icon="icon-plus"
        icon-pack="feather"
      ></vs-button>
      <AppNavbarFooterItem
        v-for="(item, index) in navigationsRight"
        :key="'r-' + index"
        :item="item"
        :active="navigationActive"
      />
      <AppNavbarDropdown class="" :navigations="navigationsDropdown" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

import AppNavbarFooterItem from "./AppNavbarFooterItem.vue";
import AppNavbarDropdown from "./AppNavbarDropdown.vue";

export default {
  components: {
    AppNavbarFooterItem,
    AppNavbarDropdown
  },

  props: {
    maxShowMobile: {
      type: Number,
      default: 4
    }
  },

  computed: {
    ...mapState({
      navigations: state => state.globalApp.navigations
    }),
    ...mapGetters({
      navigationsDropdown: "globalApp/fetchNavigationsDropdown",
      navigationActive: "globalApp/fetchNavigationActive",
      navigationAction: "globalApp/fetchNavigationAction"
    }),
    navigationsLeft() {
      return this.navigations.list.filter(data => {
        return data.showMobile === "left";
      });
    },
    navigationsRight() {
      return this.navigations.list.filter(data => {
        return data.showMobile === "right";
      });
    }
  },

  methods: {
    toggleCreate(bol) {
      if (this.navigations.action.to)
        this.$router.push({ path: this.navigations.action.to });
      else this.$store.dispatch("globalApp/toggleCreate", bol);
    }
  }
};
</script>
